import type Store from '@ember-data/store';
import type { DeviceListResponse, DeviceStatusResponse } from '@envoy/devices_client';
import type DeviceStatusModel from 'garaje/models/device-status';
import ApplicationSerializer from 'garaje/serializers/application';

export default class DeviceStatusSerializer extends ApplicationSerializer {
  normalizeResponse(
    store: Store,
    primaryModelClass: DeviceStatusModel,
    payload: DeviceListResponse | DeviceStatusResponse,
    id: string | number | null,
    requestType: string,
  ): ReturnType<ApplicationSerializer['normalizeResponse']> {
    if (requestType === 'query' || requestType === 'findAll') {
      const listPayload = payload as DeviceListResponse;
      const jsonApiPayload = {
        data: (listPayload.data || []).map((item) => toJsonApiResource(item)),
        meta: listPayload.meta || {},
      };
      return super.normalizeResponse(store, primaryModelClass, jsonApiPayload, id, requestType);
    }

    const singlePayload = payload as DeviceStatusResponse;
    const jsonApiPayload = {
      data: toJsonApiResource(singlePayload),
    };
    return super.normalizeResponse(store, primaryModelClass, jsonApiPayload, id, requestType);
  }
}

function toJsonApiResource(item: DeviceStatusResponse) {
  return {
    type: 'device-status' as const,
    id: item.id,
    attributes: {
      'company-id': item.company_id,
      product: item.product,
      'external-id': item.external_id,
      'location-id': item.location_id,
      'connection-status': item.connection_status,
      'connection-status-updated-at': item.connection_status_updated_at,
      telemetry: item.telemetry,
      'last-enrolled-at': item.last_enrolled_at,
    },
  };
}

// DO NOT DELETE: this is how TypeScript knows how to look up your serializers.
declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'device-status': DeviceStatusSerializer;
  }
}
